module.exports = __webpack_public_path__ + "static/media/logo.372e7af6.png";